//App
import { CountyDto } from "../app/model/api/types/dto";

export class CountyViewModel {
  id?: string | null;
  name: string | null;
  description: string | null;
  stateId: Array<string> | null;
  sortValue: number | null;
  isActive: boolean | null;

  constructor(
    id: string | null,
    name: string | null,
    description: string | null,
    stateId: Array<string> | null,
    sortValue: number | null,
    isActive: boolean | null
  ) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.stateId = stateId;
    this.sortValue = sortValue;
    this.isActive = isActive;
  }

  toDto(): CountyDto {
    return {
      id: this.id,
      isActive: this.isActive,
      name: this.name,
      description: this.description,
      stateId:
        this.stateId !== null && this.stateId?.length > 0
          ? this.stateId[0]
          : null,
      sortValue: Number(this.sortValue),
    };
  }

  mapFromDto(dto: CountyDto): void {
    this.id = dto.id;
    this.isActive = dto.isActive || true;
    this.name = dto.name;
    this.description = dto.description;
    dto.stateId !== null
      ? this.stateId?.push(dto.stateId)
      : (this.stateId = null);
    this.sortValue = dto.sortValue;
  }
}
